import { RoleDto } from './role-dto.model';
import { CompanyDto } from './company-dto.model';
import { NotificationUserDto } from './notification-user-dto.model';


export class UserDto implements IUserDto {
    id!: number | undefined;
    userName!: string | undefined;
    password!: string | undefined;
    fullName!: string | undefined;
    role!: RoleDto;
    profileImageUri!: string | undefined;
    isActive!: boolean;
    companyId!: CompanyDto[] | undefined;
    notificationIds!: NotificationUserDto[] | undefined;
    fcmToken!: string | undefined;
    uniqueName!: string | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.password = _data["password"];
            this.fullName = _data["fullName"];
            this.role = _data["role"] ? RoleDto.fromJS(_data["role"]) : <any>undefined;
            this.profileImageUri = _data["profileImageUri"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["companyId"])) {
                this.companyId = [] as any;
                for (let item of _data["companyId"])
                    this.companyId!.push(CompanyDto.fromJS(item));
            }
            if (Array.isArray(_data["notificationIds"])) {
                this.notificationIds = [] as any;
                for (let item of _data["notificationIds"])
                    this.notificationIds!.push(NotificationUserDto.fromJS(item));
            }
            this.fcmToken = _data["fcmToken"];
            this.uniqueName = _data["uniqueName"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["password"] = this.password;
        data["fullName"] = this.fullName;
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        data["profileImageUri"] = this.profileImageUri;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.companyId)) {
            data["companyId"] = [];
            for (let item of this.companyId)
                data["companyId"].push(item.toJSON());
        }
        if (Array.isArray(this.notificationIds)) {
            data["notificationIds"] = [];
            for (let item of this.notificationIds)
                data["notificationIds"].push(item.toJSON());
        }
        data["fcmToken"] = this.fcmToken;
        data["uniqueName"] = this.uniqueName;
        return data; 
    }
}

export interface IUserDto {
    id: number | undefined;
    userName: string | undefined;
    password: string | undefined;
    fullName: string | undefined;
    role: RoleDto;
    profileImageUri: string | undefined;
    isActive: boolean;
    companyId: CompanyDto[] | undefined;
    notificationIds: NotificationUserDto[] | undefined;
    fcmToken: string | undefined;
    uniqueName: string | undefined;
}

